/* src/app/modules/shared/expired/expired.component.scss */
/*# sourceMappingURL=expired.component-F6PSVD6M.css.map */
